exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".iframe-annotation{-webkit-overflow-scrolling:touch;overflow:scroll}\n", ""]);

